/* Pop-up d'inscription du Cercle MilAura, lot du 2026-10-02.
   Ouverture : 30 s de visite visible cumulées sur la session, après un choix dans le bandeau cookies,
   jamais en même temps qu'une autre fenêtre, une fois par session, repos de 30 jours après fermeture.
   Aperçu de revue : ?cercle_popup=1 (&cercle_etat=succes, &cercle_vitesse=0.25). Apparition en fondu. */
(function () {
  'use strict';

  var DELAI_MS = 30000;
  var APRES_COOKIES_MS = 3000;
  var REPOS_MS = 30 * 24 * 60 * 60 * 1000;
  var FORM_ID = 'MilauraCerclePopupForm';
  var CLE_TEMPS = 'milaura_cercle_temps_v1';
  var CLE_SESSION = 'milaura_cercle_vu_v1';
  var CLE_UNIVERS = 'milaura_cercle_univers_v1';
  var CLE_FERME = 'milaura_cercle_ferme_v1';
  var CLE_INSCRITE = 'milaura_cercle_inscrite_v1';
  var CLE_ONGLET_MASQUE = 'milaura_cercle_onglet_masque_v1';
  var ROUTES_EXCLUES = /^\/(cart|checkout|checkouts|account|challenge|password|policies)(\/|$)/;

  var DESTINATIONS = {
    'univers-bijoux': { url: '/collections/bijoux-pierres-naturelles', texte: 'Voir les bijoux' },
    'univers-pierres': { url: '/pages/bijoux-par-pierre?view=milaura-guide-pierres', texte: 'Choisir par pierre' },
    'univers-lithotherapie': { url: '/pages/diagnostic-emotionnel', texte: 'Trouver ma pierre' }
  };
  var DESTINATION_DEFAUT = { url: '/collections/selection-de-karine', texte: 'Voir la sélection de Karine' };

  function lireApercu(search) {
    var params = new URLSearchParams(search || '');
    if (!params.get('cercle_popup')) return null;
    var vitesse = parseFloat(params.get('cercle_vitesse'));
    return {
      etat: params.get('cercle_etat') === 'succes' ? 'succes' : 'offre',
      vitesse: vitesse > 0 && vitesse <= 1 ? vitesse : 1
    };
  }

  function lireRetour(search, hash) {
    var params = new URLSearchParams(search || '');
    return {
      inscription: params.get('customer_posted') === 'true' || params.get('email_consent') === 'success',
      popup: hash === '#' + FORM_ID,
      footer: /^#MilauraFooterNewsletter-/.test(hash || '')
    };
  }

  function doitOuvrir(etat) {
    if (ROUTES_EXCLUES.test(etat.chemin || '/')) return false;
    if (etat.inscrite || etat.vueCetteSession || etat.autreFenetre) return false;
    if (!etat.choixCookies || etat.depuisChoixCookies < APRES_COOKIES_MS) return false;
    if (etat.fermeLe && etat.maintenant - etat.fermeLe < REPOS_MS) return false;
    return etat.tempsVisible >= DELAI_MS;
  }

  /* Onglet « Vos 10 % » : après une fermeture ou un pop-up déjà vu, jusqu'à l'inscription,
     sauf s'il a été masqué il y a moins de 30 jours (choix de Patrice du 2026-10-03). */
  function doitMontrerOnglet(etat) {
    if (ROUTES_EXCLUES.test(etat.chemin || '/')) return false;
    if (etat.inscrite) return false;
    if (!etat.fermeLe && !etat.vueCetteSession) return false;
    return !(etat.ongletMasqueLe && etat.maintenant - etat.ongletMasqueLe < REPOS_MS);
  }

  function construireTags(base, univers) {
    var tags = String(base || '')
      .split(',')
      .map(function (tag) { return tag.trim(); })
      .filter(Boolean);
    (univers || []).forEach(function (valeur) {
      if (/^univers-[a-z]+$/.test(valeur) && tags.indexOf(valeur) === -1) tags.push(valeur);
    });
    return tags.join(', ');
  }

  function destination(univers) {
    if (univers && univers.length === 1 && DESTINATIONS[univers[0]]) return DESTINATIONS[univers[0]];
    return DESTINATION_DEFAUT;
  }

  window.MilauraCerclePopup = {
    lireApercu: lireApercu,
    lireRetour: lireRetour,
    doitOuvrir: doitOuvrir,
    doitMontrerOnglet: doitMontrerOnglet,
    construireTags: construireTags,
    destination: destination,
    DELAI_MS: DELAI_MS,
    REPOS_MS: REPOS_MS
  };

  var dialog = document.querySelector('[data-milaura-cercle-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var panneau = dialog.querySelector('[data-cercle-panneau]');
  var offre = dialog.querySelector('[data-cercle-offre]');
  var succes = dialog.querySelector('[data-cercle-succes]');
  var form = document.getElementById(FORM_ID);
  var champTags = dialog.querySelector('[data-cercle-tags]');
  var onglet = document.querySelector('[data-cercle-onglet]');
  var mouvementReduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var apercu = lireApercu(window.location.search);
  var vitesse = apercu ? apercu.vitesse : 1;

  function lire(stockage, cle) {
    try {
      return window[stockage].getItem(cle);
    } catch (error) {
      return null;
    }
  }

  function ecrire(stockage, cle, valeur) {
    try {
      window[stockage].setItem(cle, valeur);
    } catch (error) {
      /* Stockage indisponible : le pop-up reste limité à cette page. */
    }
  }

  /* Choix fait, ou bandeau prêt mais non requis pour ce visiteur (aucun bandeau affiché par Shopify). */
  function choixCookiesFait() {
    var marque = document.cookie.split(';').some(function (cookie) {
      return cookie.trim() === 'milaura_cookie_choice=v1';
    });
    if (marque || lire('localStorage', 'milaura_cookie_choice') === 'v1') return true;
    var bandeau = document.querySelector('[data-milaura-cookie-consent]');
    return document.documentElement.classList.contains('milaura-cookie-consent-ready') && !!bandeau && bandeau.hidden;
  }

  function autreFenetreOuverte() {
    var bandeau = document.querySelector('[data-milaura-cookie-consent]');
    if (bandeau && !bandeau.hidden) return true;
    if (document.querySelector('dialog[open]:not([data-milaura-cercle-popup])')) return true;
    return /(^|\s)overflow-hidden(-|\s|$)/.test(document.body.className);
  }

  function universChoisis() {
    return Array.prototype.slice
      .call(dialog.querySelectorAll('[data-cercle-univers]:checked'))
      .map(function (input) { return input.value; });
  }

  function appliquerCode(code) {
    if (!code || !window.fetch) return Promise.resolve(false);
    return window
      .fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function (reponse) { return reponse.ok; })
      .catch(function () { return false; });
  }

  function afficherSucces(appliquer) {
    offre.hidden = true;
    succes.hidden = false;
    dialog.setAttribute('aria-labelledby', 'MilauraCerclePopupSuccessTitle');
    var univers = [];
    try {
      univers = JSON.parse(lire('sessionStorage', CLE_UNIVERS) || '[]');
    } catch (error) {
      univers = [];
    }
    var cible = destination(univers);
    var lien = succes.querySelector('[data-cercle-destination]');
    var texte = succes.querySelector('[data-cercle-destination-texte]');
    if (lien) lien.setAttribute('href', cible.url);
    if (texte) texte.textContent = cible.texte;
    if (appliquer) {
      appliquerCode(dialog.dataset.code).then(function (ok) {
        var applique = succes.querySelector('[data-cercle-applique]');
        if (ok && applique) applique.hidden = false;
      });
    }
  }

  function dureesRalenties() {
    if (vitesse === 1) return;
    var style = window.getComputedStyle(panneau);
    function etirer(valeurs) {
      return valeurs
        .split(',')
        .map(function (valeur) { return parseFloat(valeur) / vitesse + 's'; })
        .join(', ');
    }
    panneau.style.transitionDuration = etirer(style.transitionDuration);
    panneau.style.transitionDelay = etirer(style.transitionDelay);
  }

  function afficherOnglet(visible) {
    if (!onglet) return;
    if (!visible) {
      onglet.hidden = true;
      onglet.classList.remove('is-visible');
      return;
    }
    onglet.hidden = false;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        onglet.classList.add('is-visible');
      });
    });
  }

  function ouvrir(options) {
    if (dialog.open) return;
    options = options || {};
    afficherOnglet(false);
    if (!apercu) ecrire('sessionStorage', CLE_SESSION, '1');
    dialog.classList.remove('is-fermeture', 'is-visible');
    dialog.classList.toggle('is-immediat', !!options.immediat);
    dureesRalenties();
    dialog.showModal();
    document.documentElement.classList.add('milaura-cercle-popup-ouvert');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        dialog.classList.add('is-visible');
        if (options.focusSucces) {
          var titre = succes.querySelector('[tabindex="-1"]');
          if (titre) titre.focus();
        }
      });
    });
  }

  function fermer() {
    if (!dialog.open) return;
    var offreFermee = succes.hidden;
    if (!apercu && offreFermee) ecrire('localStorage', CLE_FERME, String(Date.now()));
    dialog.classList.add('is-fermeture');
    dialog.classList.remove('is-visible');
    window.setTimeout(
      function () {
        /* L'onglet réapparaît avant la fermeture pour que le focus puisse y revenir. */
        if (offreFermee && lire('localStorage', CLE_INSCRITE) !== '1') afficherOnglet(true);
        dialog.close();
        dialog.classList.remove('is-fermeture', 'is-immediat');
        document.documentElement.classList.remove('milaura-cercle-popup-ouvert');
      },
      mouvementReduit ? 0 : 260
    );
  }

  if (onglet) {
    var boutonOnglet = onglet.querySelector('[data-cercle-onglet-ouvrir]');
    var masquerOnglet = onglet.querySelector('[data-cercle-onglet-masquer]');
    if (boutonOnglet) boutonOnglet.addEventListener('click', function () { ouvrir(); });
    if (masquerOnglet) {
      masquerOnglet.addEventListener('click', function () {
        if (!apercu) ecrire('localStorage', CLE_ONGLET_MASQUE, String(Date.now()));
        afficherOnglet(false);
      });
    }
  }

  Array.prototype.forEach.call(dialog.querySelectorAll('[data-cercle-fermer]'), function (element) {
    element.addEventListener('click', fermer);
  });
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    fermer();
  });

  if (form && champTags) {
    form.addEventListener('submit', function () {
      var univers = universChoisis();
      champTags.value = construireTags(champTags.value, univers);
      ecrire('sessionStorage', CLE_UNIVERS, JSON.stringify(univers));
    });
  }

  /* Retour du formulaire Shopify (page rechargée après l'envoi). */
  var retour = lireRetour(window.location.search, window.location.hash);
  var marqueur = dialog.querySelector('[data-cercle-posted]');
  var etatEnvoi = marqueur ? marqueur.getAttribute('data-cercle-posted') : '';
  if (retour.inscription) ecrire('localStorage', CLE_INSCRITE, '1');

  if (apercu) {
    if (apercu.etat === 'succes') afficherSucces(false);
    window.setTimeout(function () { ouvrir(); }, 700);
    return;
  }

  if (retour.popup && (etatEnvoi === 'succes' || retour.inscription)) {
    ecrire('localStorage', CLE_INSCRITE, '1');
    afficherSucces(true);
    ouvrir({ immediat: true, focusSucces: true });
    return;
  }

  /* Inscription depuis le footer : même écran de succès, en fondu. Shopify vise le formulaire
     avant le chargement des images ; on y revient une fois la page chargée. */
  if (retour.footer && retour.inscription) {
    afficherSucces(true);
    ouvrir({ focusSucces: true });
    window.addEventListener('load', function () {
      var formulaire = document.getElementById(window.location.hash.slice(1));
      if (formulaire) formulaire.scrollIntoView({ block: 'center' });
    });
    return;
  }

  if (retour.popup && etatEnvoi === 'erreur') {
    ouvrir({ immediat: true });
    return;
  }

  if (
    doitMontrerOnglet({
      chemin: window.location.pathname.toLowerCase(),
      maintenant: Date.now(),
      inscrite: dialog.dataset.subscribed === 'true' || lire('localStorage', CLE_INSCRITE) === '1',
      vueCetteSession: lire('sessionStorage', CLE_SESSION) === '1',
      fermeLe: parseInt(lire('localStorage', CLE_FERME) || '0', 10) || 0,
      ongletMasqueLe: parseInt(lire('localStorage', CLE_ONGLET_MASQUE) || '0', 10) || 0
    })
  ) {
    afficherOnglet(true);
  }

  /* Déclenchement différé. */
  var cookiesAuChargement = choixCookiesFait();
  var choixVuLe = cookiesAuChargement ? 0 : null;
  var dernierTic = null;
  var intervalle = null;

  function tic() {
    var maintenant = Date.now();
    if (document.visibilityState !== 'visible') {
      dernierTic = null;
      return;
    }
    var temps = parseInt(lire('sessionStorage', CLE_TEMPS) || '0', 10) || 0;
    if (dernierTic !== null) temps += Math.min(maintenant - dernierTic, 5000);
    dernierTic = maintenant;
    ecrire('sessionStorage', CLE_TEMPS, String(temps));

    var choix = choixCookiesFait();
    if (choix && choixVuLe === null) choixVuLe = maintenant;

    var etat = {
      chemin: window.location.pathname.toLowerCase(),
      maintenant: maintenant,
      tempsVisible: temps,
      choixCookies: choix,
      depuisChoixCookies: choixVuLe === 0 ? Infinity : choixVuLe === null ? 0 : maintenant - choixVuLe,
      inscrite: dialog.dataset.subscribed === 'true' || lire('localStorage', CLE_INSCRITE) === '1',
      vueCetteSession: lire('sessionStorage', CLE_SESSION) === '1',
      fermeLe: parseInt(lire('localStorage', CLE_FERME) || '0', 10) || 0,
      autreFenetre: autreFenetreOuverte()
    };

    if (etat.inscrite || etat.vueCetteSession || ROUTES_EXCLUES.test(etat.chemin)) {
      window.clearInterval(intervalle);
      return;
    }
    if (doitOuvrir(etat)) {
      window.clearInterval(intervalle);
      ouvrir();
    }
  }

  intervalle = window.setInterval(tic, 1000);
  document.addEventListener('visibilitychange', tic);
  tic();
})();
